import { render, staticRenderFns } from "./CallToActionSettings.vue?vue&type=template&id=337ef5b5&scoped=true"
import script from "./CallToActionSettings.vue?vue&type=script&lang=js"
export * from "./CallToActionSettings.vue?vue&type=script&lang=js"
import style0 from "./CallToActionSettings.vue?vue&type=style&index=0&id=337ef5b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337ef5b5",
  null
  
)

export default component.exports